import { ApiError } from "../../Services/http";

type Props = {
  /** Satt när senaste hämtningen misslyckades. */
  error: unknown;
  /** Kartflödet har svarat minst en gång. */
  hasLoaded: boolean;
  isRetrying: boolean;
  onRetry: () => void;
};

const isNetworkError = (error: unknown) =>
  error instanceof ApiError && error.code === "network_error";

/**
 * Vad kartan säger när flödet inte går att nå.
 *
 * Två lägen, och skillnaden är hela poängen. Har kartan redan ställen
 * ligger de kvar och en diskret rad säger att de kan vara gamla — en
 * tappad poll ska inte tömma kartan. Har den aldrig fått något finns inget
 * att visa, och då är tystnad värre än ett riktigt felläge med ett sätt
 * att försöka igen.
 */
export default function MapFeedStatus({ error, hasLoaded, isRetrying, onRetry }: Props) {
  if (!error) return null;

  if (hasLoaded) {
    return (
      <div className="map-feed-banner" role="status">
        <span>Can&apos;t reach the server — showing the last known state.</span>
        <button type="button" onClick={onRetry} disabled={isRetrying}>
          {isRetrying ? "Trying…" : "Try again"}
        </button>
      </div>
    );
  }

  return (
    <div className="map-feed-error" role="alert">
      <p className="map-feed-error-title">
        {isNetworkError(error) ? "Can't reach the server" : "Could not load the map"}
      </p>
      <p className="map-feed-error-text">
        {isNetworkError(error)
          ? "Check your connection and try again."
          : "Something went wrong on our side. Try again in a moment."}
      </p>
      <button type="button" onClick={onRetry} disabled={isRetrying}>
        {isRetrying ? "Trying…" : "Try again"}
      </button>
    </div>
  );
}
